import classNames from 'classnames';
import { GruenlandFooterLogo } from 'components/svgr/GruenlandFooterLogo';

export const FooterLogo: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <div className={classNames('w-full text-center', className)}>
      <GruenlandFooterLogo className="w-full" />
    </div>
  );
};
